import type { FeatureManagerDialogType } from '../../feature-manager/types';

export const SPORT_BASE_PATH = 'sports';

export const SPORTS_DIALOG_TYPES: Record<string, FeatureManagerDialogType> = {
  game_of_the_day: 'GameOfTheDay',
  toto: 'Toto',
};

export const SPORT_EVENTS_PATHS = {
  GAME_OF_THE_DAY: 'game_of_the_day',
  TOTO: 'toto',
};
